import jwt_decode from 'jwt-decode'

export default class Claims {
  public id: string = ''
  public name: string = ''
  public email: string = ''
  public orgId: string = ''
  public orgName: string = ''
  public orgType: number = 0
  public roles: Array<string> = []
  public groupIds: Array<string> = []

  constructor(
    id: string,
    name: string,
    email: string,
    orgId: string,
    orgName: string,
    orgType: number,
    roles: Array<string>,
    groupIds: Array<string>
  ) {
    this.id = id
    this.name = name
    this.email = email
    this.orgId = orgId
    this.orgName = orgName
    this.orgType = orgType
    this.roles = roles
    this.groupIds = groupIds
  }

  public decodeToken(accessToken: string) {
    const decodedToken = jwt_decode(accessToken)
    return decodedToken
  }
}
